import 'react-calendar/dist/Calendar.css';
import Calendar from 'react-calendar/dist/cjs/Calendar.js';
import moment from 'moment/moment';
import '../styles/calendar.css';
import { Card } from './ui/card';
import s from '../styles/modules/Calendar.module.scss';
import { useCalendar } from '../hooks/useCalendar';

const CalendarComponent = () => {
  const { value, onChange, dateArr } = useCalendar();
  return (
    <Card className={`${s.calendar} flex min-w-[350px] mx-auto md:ml-0 items-center shadow-sm`}>
      <Calendar
        onChange={(value: Date) => onChange(value)}
        value={value}
        tileClassName={({ date }) => {
          if (dateArr && dateArr.find((x) => x === moment(date).format('YYYY-MM-DD'))) {
            return 'highlight';
          }
        }}
      />
    </Card>
  );
};
export default CalendarComponent;
